import style from './home.module.css';

function Home({visibleElements, elementsRef}) {
  return (
    <section id={'home'} className={style['home']}>

      <div className={style['home__container']}>

        <div className={style['home__section']} ref={(el) => (elementsRef.current[1] = el)}>

          <h1 className={`${style['home__title']}
          ${visibleElements.includes(elementsRef.current[1]) ?
              style['home__title--transition'] : ''}`}>
            Innovación Digital: Desarrollo Web y Videojuegos Indie.
          </h1>

          <h2 className={`${style['home__subtitle']}
          ${visibleElements.includes(elementsRef.current[1]) ?
              style['home__subtitle--transition'] : ''}`}>
            Diseñamos experiencias digitales para empresas y jugadores.
          </h2>

          <p className={`${style['home__description']} 
          ${visibleElements.includes(elementsRef.current[1]) ?
              style['home__description--transition'] : ''}`}>
            Desarrollamos sitios web modernos y videojuegos indie para
            plataformas digitales, combinando tecnología y creatividad
            en soluciones personalizadas.
          </p>

          <p className={`${style['home__description']} 
          ${visibleElements.includes(elementsRef.current[1]) ?
              style['home__description--transition'] : ''}`}>
            ¡Mantente al tanto de nuestras próximas soluciones!
          </p>

        </div>

      </div>

    </section>
  );
}

export default Home;
